<template>
    <div>
        <div v-if="promotionPrice == 0" class="course-price"><span class="price">免费</span></div>
        <div v-else class="course-price">
            <span class="price"><em>¥</em>{{promotionPrice}}</span>
            <span class="orig_price"><em>¥</em>{{res.price}}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        res: {
            type: Object,
            default() {
                return {};
            }
        },
        urgeInfo: {
            type: Object,
            default() {
                return null;
            }
        }
    },
    computed: {
        promotionPrice() {
            if (!this.urgeInfo) {
                return 0;
            }
            return this.urgeInfo.promotionPrice;
        }
    }
};
</script>

<style lang="less" scoped>
@import "./price.less";
</style>
